import { React } from "react";
import img from "../images/pic.jpg";
import "../styles/home.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const heroTags = ["Kubernetes", "GCP", "Azure", "Terraform", "ArgoCD", "Python", "Go"];

function Home() {
  return (
    <motion.div
      className="home page"
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5 }}
    >
      <div className="hero">
        <div className="hero__content">
          <p className="hero__kicker">Hi, I'm</p>
          <h1 className="hero__name">Kamlesh Joshi</h1>
          <h2 className="hero__role">
            Platform · DevOps · AI Infrastructure Engineer
          </h2>
          <p className="hero__tagline">
            Software Engineer in Production Engineering at <b>Egnyte</b>.
            I build, automate, and operate cloud infrastructure and AI/ML
            platforms on Kubernetes across GCP, Azure, and on-prem.
          </p>
          <div className="hero__tags">
            {heroTags.map((tag) => (
              <span className="tag" key={tag}>
                {tag}
              </span>
            ))}
          </div>
          <div className="hero__actions">
            <a
              className="btn btn--primary"
              href="/Kamlesh_Joshi_resume.pdf"
              rel="noreferrer"
              target="_blank"
            >
              View Resume
            </a>
            <Link className="btn" to="/experience">
              Experience
            </Link>
            <Link className="btn" to="/about">
              About Me
            </Link>
          </div>
        </div>
        <div className="hero__img">
          <img src={img} alt="Kamlesh Joshi" className="img-main" />
        </div>
      </div>
    </motion.div>
  );
}

export default Home;
